"use client";

import Link from "next/link";

import { useAuth } from "@/components/auth/auth-provider";
import { McpConnectionInstructions } from "@/components/admin/mcp-connection-instructions";
import { PillNav } from "@/components/nav/pill-nav";
import { RasterField } from "@/components/v2/raster-field";

import "../app-v2.css";

/* MCP integration guide — design system v2 ("Dune"). Layout from
   `design_handoff_alister_app/app-static.html`. */
export default function SettingsPage() {
  const { user, isAdmin, isLoading: authLoading } = useAuth();

  const shell = (children: React.ReactNode) => (
    <div className="al-v2">
      <RasterField />
      <PillNav variant="app" />
      <main className="al-mcp-page">{children}</main>
    </div>
  );

  if (authLoading) {
    return shell(
      <div className="al-loading al-frost">
        <span className="dot">
          <i />
        </span>
        <span className="lbl">Loading…</span>
      </div>
    );
  }

  if (!user) {
    return shell(
      <>
        <span className="al-kicker al-kicker-outline">
          <span className="al-dots">
            <i style={{ background: "var(--al-red)" }} />
            <i style={{ background: "var(--al-amber)" }} />
            <i style={{ background: "var(--al-blue)" }} />
          </span>
          MCP integration guide
        </span>
        <h1>
          Sign in to <em>connect</em> Alister
        </h1>
        <p className="al-mcp-lead">
          The MCP setup guide is tied to your account — your client signs in with the same
          Alister credentials. Sign in and the five-minute setup is waiting for you here.
        </p>
        <Link className="al-btn-claude" href="/login?next=%2Fsettings">
          <i />
          Sign in
        </Link>
      </>
    );
  }

  return shell(
    <>
      <McpConnectionInstructions defaultOpen />

      <div className="al-mcp-foot">
        {isAdmin && (
          <Link className="al-btn al-btn-ghost" href="/search">
            Use Simple Search instead
          </Link>
        )}
        <span className="note">5-minute setup · no API key</span>
      </div>

      <div className="al-mcp-signed">
        <span>
          Signed in as <strong>{user.email}</strong> ({user.role}) ·{" "}
          <Link href="/account">Account settings</Link>
        </span>
        <span>Questions? hello@alisterai.com</span>
      </div>
    </>
  );
}
